import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Sale } from '@/schemas/sales';

interface SalesState {
  byId: Record<string, Sale>;
  allIds: string[];
  filters: {
    search?: string;
    status?: string;
    dateFrom?: string;
    dateTo?: string;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: SalesState = {
  byId: {},
  allIds: [],
  filters: {},
  isLoading: false,
  error: null,
};

const salesSlice = createSlice({
  name: 'sales',
  initialState,
  reducers: {
    setSales: (state, action: PayloadAction<Sale[]>) => {
      state.byId = {};
      state.allIds = [];
      action.payload.forEach((sale) => {
        state.byId[sale.id] = sale;
        state.allIds.push(sale.id);
      });
    },
    addSale: (state, action: PayloadAction<Sale>) => {
      const sale = action.payload;
      state.byId[sale.id] = sale;
      if (!state.allIds.includes(sale.id)) {
        state.allIds.push(sale.id);
      }
    },
    updateSale: (state, action: PayloadAction<Sale>) => {
      const sale = action.payload;
      state.byId[sale.id] = sale;
    },
    deleteSale: (state, action: PayloadAction<string>) => {
      delete state.byId[action.payload];
      state.allIds = state.allIds.filter((id) => id !== action.payload);
    },
    setFilters: (state, action: PayloadAction<Partial<SalesState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setSales, addSale, updateSale, deleteSale, setFilters, setLoading, setError } =
  salesSlice.actions;

export default salesSlice.reducer;
